import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Space, Tag, theme } from 'antd';
import { IngredientCatalogDto, CatalogSource } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';
import { LocalizedContentShow } from '../../components/LocalizedContentTabs';

export const IngredientCatalogShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<IngredientCatalogDto>({ resource: 'ingredient-catalog' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="ingredient-catalog">
      <div style={{ padding: '8px 0' }}>
        <LocalizedContentShow
          record={item}
          fields={[{ key: 'name', label: 'Name' }]}
        />

        <div
          style={{
            borderTop: `1px solid ${token.colorBorderSecondary}`,
            paddingTop: 16,
          }}
        >
          <Field label="Category">{item.category}</Field>
          <Field label="Default Amount">{item.defaultAmountGrams} {item.defaultAmountUnit}</Field>
          <Field label="Calories per 100g">{item.caloriesPer100g}</Field>
          <Field label="Protein per 100g">{item.proteinPer100g} g</Field>
          <Field label="Fat per 100g">{item.fatPer100g} g</Field>
          <Field label="Carbs per 100g">{item.carbsPer100g} g</Field>
          <Field label="Fiber per 100g">{item.fiberPer100g != null ? `${item.fiberPer100g} g` : '—'}</Field>
          <Field label="Sodium per 100g">{item.sodiumPer100g != null ? `${item.sodiumPer100g} mg` : '—'}</Field>
          <Field label="Common Allergens">
            {(item.commonAllergens || []).length > 0 ? item.commonAllergens.join(', ') : '—'}
          </Field>
          <Field label="Tags">
            {(item.tags || []).length > 0 ? (
              <Space wrap>
                {item.tags.map((t) => (
                  <Tag key={t} style={{ borderRadius: 9999, padding: '2px 10px' }}>
                    {t}
                  </Tag>
                ))}
              </Space>
            ) : (
              '—'
            )}
          </Field>
          <Field label="Active">
            <Tag
              style={{
                borderColor: item.isActive ? '#3ecf8e' : '#898989',
                color: item.isActive ? '#3ecf8e' : '#898989',
                background: item.isActive ? '#3ecf8e15' : '#89898915',
                borderRadius: 9999,
                padding: '2px 12px',
                fontWeight: 500,
              }}
            >
              {item.isActive ? 'Active' : 'Inactive'}
            </Tag>
          </Field>
          <Field label="Source">
            <Tag
              style={{
                borderColor: item.source === CatalogSource.USDA ? '#52c41a' : item.source === CatalogSource.CFS ? '#1890ff' : '#d9d9d9',
                color: item.source === CatalogSource.USDA ? '#52c41a' : item.source === CatalogSource.CFS ? '#1890ff' : '#666',
                borderRadius: 9999,
                padding: '2px 12px',
                fontWeight: 500,
              }}
            >
              {item.source || CatalogSource.MANUAL}
            </Tag>
          </Field>
          <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
          <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
        </div>
      </div>
    </Show>
  );
};
